import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
var config = {
    apiKey: "AIzaSyDGXC7QFxSfM6m9VrQjDbxbM3exTUXtZ7s",
    authDomain: "fp-contactform.firebaseapp.com",
    databaseURL: "https://fp-contactform.firebaseio.com",
    projectId: "fp-contactform",
    storageBucket: "fp-contactform.appspot.com",
    messagingSenderId: "869801902867"
};
firebase.initializeApp(config);

// Reference message collection
var messagesRef = firebase.database().ref('messages');
